import { useState } from "react";
import { RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { useWorkspace } from "../../context/WorkspaceContext";

export function RefreshButton({ className = "" }) {
  const { refreshWorkspace } = useWorkspace();
  const [spin, setSpin] = useState(false);
  const onClick = async () => {
    if (spin) return;
    setSpin(true);
    try {
      await refreshWorkspace();
      toast.success("Data refreshed");
    } finally {
      setTimeout(() => setSpin(false), 400);
    }
  };
  return (
    <button
      data-testid="refresh-data-button"
      onClick={onClick}
      title="Refresh this section's data"
      className={`rounded-md p-2 text-slate-400 transition-colors hover:bg-slate-100 hover:text-teal-700 ${className}`}
    >
      <RefreshCw className={`h-4 w-4 ${spin ? "animate-spin" : ""}`} />
    </button>
  );
}
